/**
 * @prettier
 */

const partnerImages = JSON.parse(
  document.querySelector('.js-partner-images').dataset.value,
)
let interval
let changedCells = []
const period = 1000
const animationDuration = 1000

function getRandomInt({ min, max, except = [] }) {
  const result = Math.floor(Math.random() * (max - min + 1) + min)

  if (except.includes(result)) {
    return getRandomInt({ min, max, except })
  } else {
    return result
  }
}

function rerender({ $elem, index }) {
  let currentIndex = Number($elem.attr('data-current-index')) + 1

  currentIndex = currentIndex >= partnerImages[index].length ? 0 : currentIndex
  $elem.attr('data-current-index', currentIndex)
  $elem.find('.js-logo-partner:visible').fadeOut(animationDuration, () => {
    $elem
      .find('.js-logo-partner')
      .eq(currentIndex)
      .fadeIn(animationDuration, () => {
        intervalInit()
      })
  })
}

function loadAllLogos() {
  partnerImages.forEach((cellImages, index) => {
    cellImages.forEach((imageUrl, ii) => {
      const $img = $(
        `<img src="${imageUrl}" class="js-logo-partner logo-partner-section-img" alt='Partner - referral marketing'/>`,
      )

      if (ii !== 0) {
        $img.hide()
      }
      $('.js-logo-partner-cell').eq(index).append($img)
    })
  })
}

function intervalInit() {
  interval = setInterval(function () {
    clearInterval(interval)
    let currentCellIndex

    if (changedCells.length > 5) {
      changedCells = changedCells.slice(-1)
      currentCellIndex = getRandomInt({ min: 0, max: 5, except: changedCells })
      changedCells.pop()
    } else {
      currentCellIndex = getRandomInt({ min: 0, max: 5, except: changedCells })
    }
    let $elem = $('.js-logo-partner-cell').eq(currentCellIndex)

    changedCells.push(currentCellIndex)
    rerender({ $elem, index: currentCellIndex })
  }, period)
}

document.addEventListener('DOMContentLoaded', () => {
  loadAllLogos()
  setTimeout(intervalInit, period)
})
